import PropTypes from 'prop-types';

import { Tooltip } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';

/**
 * An Info icon wrapped in an MUI Tooltip that shows `title` on hover.
 * Use to attach explanatory hover text next to a label or form field.
 */
const TooltipIcon = ({ placement, title }) => (
  <Tooltip placement={placement} title={title}>
    <InfoIcon />
  </Tooltip>
);

TooltipIcon.defaultProps = {
  placement: 'top-start',
};

TooltipIcon.propTypes = {
  placement: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default TooltipIcon;
